<template lang="pug">
	v-card.padding
		h1(class="fonte") HISTÓRICO DE CAMPANHAS
		p(class="black--text") Abaixo, seu histórico de campanhas
		v-divider.mt-4

		v-card
			v-card-title
				| Últimas campanhas
				v-spacer
				v-text-field(v-model='search', color="blue-grey" append-icon='search', label='Pesquisar', single-line='', hide-details='')

			v-data-table(:headers='headers', :items='mensagens', :search='search')
				template(slot='items', slot-scope='props')
					td.text-xs-center
						a(:href="props.item.imagem" target="_blank") Ver imagem
					td.text-xs-center {{ props.item.titulo }}
					td.text-xs-center {{ props.item.descricao }}
					td.text-xs-center {{ props.item.download }}

				v-alert(slot='no-results', :value='true', color='error', icon='warning')
					|	Sua busca por &quot;{{ search }}&quot; não retornou resultados.

</template>


<script>
  export default {
    data () {
      return {
        search: '',
        headers: [
          { text: 'Imagem', value: 'imagem', align:'center' },
          { text: 'Titulo', value: 'titulo', align:'center' },
          { text: 'Descricao', value: 'descricao', align:'center' },
          { text: 'Download', value: 'download', align:'center' }
        ],
        mensagens: [
          {
            value: false,
            imagem: 'https://kanto.legiaodosherois.com.br/w750-h393-gnw-cfill-q80/wp-content/uploads/2018/09/legiao_C80q7wxvjcAVbkD2_51BeQf3iKhoUgFlOWEdYp9zLa.png.jpeg',
            titulo: 159,
            descricao: 6.0,
            download: 24
          }
        ]
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .d-flex
    display flex
    justify-content space-between
    margin-bottom 30px

</style>



// WEBPACK FOOTER //
// src/components/user/push/MinhasCampanhas.vue